import { Component, OnInit } from '@angular/core';
import { Platform, NavController } from '@ionic/angular';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service'
import { LangactionService } from 'src/app/service/lang/langaction.service';
import { ActionlistenService } from 'src/app/service/actionlisten.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnInit {
  languageLists: any = [];
  selectedLanguage: any;
  langJson: any;
  langcontext: any = [];
  headerTitle: any;
  storedDetails: any;
  appDetails: any;


  constructor(public navCtrl: NavController, public actionVal: ActionlistenService, public langAction: LangactionService, public platform: Platform, public api: RestapiService, private router: Router, public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService) {
    this.platform.ready().then(async () => {
      if (this.router.url == "/changelanguage") {
        this.selectedLanguage = localStorage.language
        this.langcontext = JSON.parse(localStorage.languageJson);
        this.langcontext = this.langcontext['pages'][0].languageupdate;
        this.headerTitle = this.langcontext.heading.text;

        await this.api.postapi('getLanguageDetails', {}).then(data => {
          this.languageLists = data['LanguageDetails'];
          console.log(this.languageLists);
        }, err => {
          console.log(err);
        });
      } else {
        if (localStorage.tourstatus == "Visited") {
          if (localStorage.logined != null && localStorage.logined != undefined && !(localStorage.freezetime)) {
            sessionStorage.CurrentPage = "/loginva"
            this.navCtrl.navigateRoot("/loginva")
          }
          else {
            if (localStorage.role == "" || localStorage.role == undefined || localStorage.role != "new") {
              if (localStorage.freezetime) {
                sessionStorage.CurrentPage = "/freezescreen"
                this.navCtrl.navigateRoot("/freezescreen")
              }
              else {
                localStorage.removeItem("user");
                localStorage.removeItem("dobdate");
                localStorage.removeItem("logined");
                localStorage.removeItem("role");
                localStorage.removeItem("dob");
                localStorage.removeItem("state");
                this.cmndecl.deleteProcess("profile");
                localStorage.removeItem("logout");
                this.cmndecl.deletefile();
                this.cmndecl.ChatFullHistory=[];
                this.cmndecl.ChatfullList =[];
                this.cmndecl.capsuleList = [];
                localStorage.removeItem("uniqueId");
                localStorage.removeItem("userChatSessionId");
                localStorage.removeItem("userSessionID");
                sessionStorage.CurrentPage = "/preRegister"
                this.navCtrl.navigateRoot("/preRegister")
              }
            }
            else {
              sessionStorage.CurrentPage = "/va/chat"
              this.navCtrl.navigateRoot("/va/chat");
            }
          }
        } else {
          this.selectedLanguage = "en"
          this.changeLanguage(this.selectedLanguage);
          localStorage.language = this.selectedLanguage;
          sessionStorage.CurrentPage = "/language"
          this.cmndecl.getJson(this.selectedLanguage, "set").then(data => {
            this.langcontext = data['pages'][0].languageupdate;
            this.headerTitle = this.langcontext.heading.text
          }, err => {
            console.log(err);
          });

          await this.api.postapi('getLanguageDetails', {}).then(data => {
            this.languageLists = data['LanguageDetails'];
          }, err => {
            console.log(err);
          });
        }
      }
    });
  }

  ngOnInit() {
  }

  async changeLanguage(selected) {
    this.selectedLanguage = selected;
    console.log(this.selectedLanguage);
    await this.cmndecl.getJson(this.selectedLanguage, "no").then(data => {
      this.langJson = JSON.stringify(data);
      this.langcontext = data['pages'][0].languageupdate;
      this.headerTitle = this.langcontext.heading.text
    }, err => {
      console.log(err);
    })

  }

  updatelanguage() {
    let res: any;
    if (this.router.url == "/changelanguage") {
      this.cmndef.loaderstart();
      var data = {
        "langCode": this.selectedLanguage,
        "userSessionID": localStorage.userSessionID,
        "userChatSessionID": localStorage.userChatSessionId
      };
      this.api.clickenventcap("updateLanguageButton");
      this.api.postapi('setLanguageDetails', data).then(async data => {
        if (data) {
          localStorage.language = this.selectedLanguage;
          await this.cmndecl.getJson(this.selectedLanguage, "set").then(data => {
            localStorage.languageJson = JSON.stringify(data);
            this.cmndecl.LanguageJson = data;
            this.langAction.languagechange("update language");
            this.api.postapi("getContextMenu", {}).then(async data => {
              console.log(data);
              await this.cmndecl.storeProcess(data,"contexualmenu");  
              this.cmndecl.functionCall = "menu";
              this.actionVal.filter("menu");
              this.api.postapi("getProfiletMenu", {}).then(data => {
                res = data;
                this.cmndecl.storeProcess(res.menu, "profileMenu");
                sessionStorage.CurrentPage = "/va/chat";
                this.navCtrl.navigateRoot("/va/chat");
                this.cmndef.loaderend();
              }, err => {
                console.log(err);
                this.cmndef.loaderend();
              })
            }, err => {
              this.cmndef.loaderend();
              console.log("err");
            })
          }, err => {
            this.cmndef.loaderend();
            console.log(err);
          })
        };
      }, err => {
        console.log(err);
        this.cmndef.loaderend();
      })
    }
    else {
      localStorage.language = this.selectedLanguage;
      localStorage.languageJson = this.langJson;
      this.cmndecl.LanguageJson = JSON.parse(this.langJson);
      this.langAction.languagechange("update language");
      sessionStorage.CurrentPage = "/guideTour"
      this.navCtrl.navigateRoot("/guideTour");
      // this.getOnLaunchConfig();
    }
  }

  // getOnLaunchConfig() {
  //   var data = {};
  //   this.api.postapi('getOnLaunchConfig', data).then(res => {
  //     console.log(res);
  //     this.appDetails = res;
  //     this.cmndecl.storeProcess(this.appDetails.Grammar,'Grammer');
  //     this.cmndecl.storeProcess(this.appDetails.NomineeSalutationWithGen,'nomineeSaluation');
  //     this.cmndecl.storeProcess(this.appDetails.NominineeCountry,'nomineeCountry');
  //     this.cmndecl.storeProcess(this.appDetails.NominineeRelationWithGen,'nomineeRelation');
  //     this.cmndecl.storeProcess(this.appDetails.NomineeNationality,'nomineeNationality');
  //     this.cmndecl.storeProcess(this.appDetails.NomineeSalutationWithGen,'nomineesalgen');
  //     this.cmndecl.storeProcess(this.appDetails.NominineeRelationWithGen,'nomineerelationgen');
  //     this.cmndef.greetingupdate = this.appDetails.greetingUpdate;
  //     this.cmndef.greetingmessage = this.appDetails.greetingMessage;
  //     localStorage.imgsize = this.appDetails.ImageSizecap;
  //     if(this.appDetails.ImageQuality != undefined && this.appDetails.ImageQuality != '' && this.appDetails.ImageQuality != 'null')
  //       localStorage.imagequality = this.appDetails.ImageQuality;
  //     else
  //       localStorage.imagequality = 70;

  //     if (this.appDetails.AppVersion != null || this.appDetails.AppVersion != "") {
  //       var updateV = parseInt(this.appDetails.AppVersion.replace(/\./g, '')),
  //         betaV = parseInt(this.appDetails.betaVersion.replace(/\./g, ''));
  //       this.cmndef.updateV = updateV;
  //       this.cmndef.betaV = betaV;
  //       this.cmndef.MaintenanceRequired = this.appDetails.MaintenanceRequired;
  //       if (this.appDetails.MaintenanceRequired == "1") {
  //       }
  //       else { }
  //     }
  //   }, function (error) {

  //   });

  // }

}
